import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useLocation } from "react-router-dom";
import config from "../../../config/config";
import { Box } from "@mui/material";
import axios from "axios";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_EXISTS,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import Select from "react-select";
import CommonMultiSelect from "../../../components/MultiSelect/CommonMultiSelect";
import { Noimage } from "../../../common/imagePath";

function InventoryStockStatusByCategory() {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const Location = localStorage.getItem("Location");

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const categoryId = query.get("categoryId") || 0;
  const categoryName = query.get("categoryName");

  const [searchItemName, setSearchItemName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [cursorIndex, setCursorIndex] = useState(0);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [brandId, setBrandId] = useState([]);
  // const [slugCategroryList, setSlugCategroryList] = useState([]);
  const [slugId, setSlugId] = useState(0);

  console.log(slugId, "slugId");

  const getbreandsList = () => {
    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });

        setBrandsList(datalist);
      })
      .catch((err) => {});
  };

  const getSlugListData = async () => {
    // setLoading(true);
    await axios
      .get(
        `${config.categoriesBaseUrl}/categories/inventoryStockStatusCategoriesList`
      )
      .then((res) => {
        // setSlugCategroryList(res.data.ResponseData);
        const sId =
          res.data.ResponseData?.find((item) => item.slug === categoryName)
            ?.id || 0;
        setSlugId(sId);

        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
      });
  };

  useEffect(() => {
    getSlugListData();
    getbreandsList();
  }, []);

  useEffect(() => {
    if (searchItemName) {
      const handler = setTimeout(() => {
        handleListData();
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    } else {
      setSuggestions([]);
    }
  }, [searchItemName]);

  const handleSwitchOnOff = (e, row) => {
    const { checked, name } = e.target;

    const updatedData = data.map((el) => {
      if (
        el.ID === row.original.ID &&
        el.VariationId === row.original.VariationId
      ) {
        return {
          ...el,
          [name]: checked ? 1 : 0,
        };
      } else {
        return el;
      }
    });
    setData(updatedData);

    // Find the updated object
    const updatedItem = updatedData.find(
      (el) =>
        el.ID === row.original.ID && el.VariationId === row.original.VariationId
    );

    // Pass the updated object to the function
    updateItemIsPublicOutOfStock(updatedItem);
  };

  const deleteItemfromInventoryStockStatus = (itemId, variationId) => {
    axios
      .post(
        `${config.categoriesBaseUrl}/categories/deleteItemfromInventoryStockStatus`,
        {
          itemId,
          variationId,
          slugId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseCode);
          if (variationId == 0) {
            const finalData = data?.filter((el) => {
              return el.ID != itemId;
            });
            setData(finalData);
          } else {
            const finalData = data?.filter((el) => {
              return !(el.ID == itemId && el.VariationId == variationId);
            });
            setData(finalData);
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
        } else {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      // size: 100,
      Cell: ({ row }) => (
        <>
          {row.original.VariationId > 0
            ? row.original.ID + "#" + row.original.VariationId
            : row.original.ID}
        </>
      ),
    },
    {
      header: "Name",
      accessorKey: "Name",
      // size: 80,
    },
    {
      header: "Cus. Out Stock",
      accessorKey: "isPublicOutOfStock",
      // size: 80,
      Cell: ({ row }) => (
        <>
          {/* {row.original.Lable === "Individual" && ( */}
          <input
            class="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            name="isPublicOutOfStock"
            checked={row.original.isPublicOutOfStock === 1}
          />
          {/* )} */}
        </>
      ),
    },
    {
      header: "Whl. Out Stock",
      accessorKey: "isWholesaleOutOfStock",
      Cell: ({ row }) => (
        <>
          {/* {row.original.Lable === "Individual" && ( */}
          <input
            class="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            name="isWholesaleOutOfStock"
            checked={row.original.isWholesaleOutOfStock === 1}
          />
          {/* )} */}
        </>
      ),
    },
    {
      header: "Cus Itm Hide",
      accessorKey: "isPublicHide",
      Cell: ({ row }) => (
        <>
          {/* {row.original.Lable === "Individual" && ( */}
          <input
            class="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            name="isPublicHide"
            checked={row.original.isPublicHide === 1}
          />
          {/* )} */}
        </>
      ),
    },
    {
      header: "Whl. Itm. Hide",
      accessorKey: "isWholesaleHide",
      Cell: ({ row }) => (
        <>
          {/* {row.original.Lable === "Individual" && ( */}
          <input
            class="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            name="isWholesaleHide"
            checked={row.original.isWholesaleHide === 1}
          />
          {/* )} */}
        </>
      ),
    }, // checkbox
    {
      header: "Qty.",
      accessorKey: "Quantity",
      // size: 110,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Quantity !== null ? row.original.Quantity : 0
        ).toFixed(2),
    },
    {
      header: "Current Stock Status",
      accessorKey: "status",
      // size: 110,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color:
              row.original.Quantity > 0
                ? "var(--success-main-color)"
                : "var(--error-main-color)",
            maxWidth: "9ch",
            p: "0.3rem",
            fontWeight: "bold",
          })}
        >
          {row.original.Quantity > 0 ? "In Stock" : "Out Of Stock"}
        </Box>
      ),
    },
    {
      header: "Brand",
      accessorKey: "Brand",
      // size: 110,
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.Brand}</p>
      ),
    },
    {
      header: "Category",
      accessorKey: "Categoryfullpath",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row?.original?.Categoryfullpath}>
          {row?.original?.Categoryfullpath}
        </p>
      ),
    },
    {
      header: "Delete",
      accessorKey: "delete",
      Cell: ({ row }) => {
        return (
          <div>
            <div
              className="btn btn-primary"
              onClick={() => {
                deleteItemfromInventoryStockStatus(
                  row.original.ID,
                  row.original.VariationId
                );
              }}
            >
              X
            </div>
          </div>
        );
      },
    },
  ];

  console.log(data, "data");

  const handleListData = () => {
    setSuggestions([]);
    axios
      .get(
        `${config.itemsBaseUrl}/items?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagenumber=1&pagesize=0&filtertext=${searchItemName}&startdate=&enddate=&categoryid=${categoryId}&tagid=&supplierid=&itemType=0&LocationID=${Location}&loginId=${loginUserId}&BrandId=0&slugId=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setSuggestions(res.data.ResponseData?.list);
        if (res.data.ResponseData?.list.length === 0) {
          toastError("No Product Found on this Categories");
        }
      })
      .catch((err) => {
        // setLoading(false);
      });
  };

  const handelItemData = async () => {
    setLoading(true);
    await axios
      .get(
        `${config.itemsBaseUrl}/items?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagenumber=1&pagesize=0&filtertext=&startdate=&enddate=&categoryid=${categoryId}&tagid=&supplierid=&itemType=0&LocationID=${Location}&loginId=${loginUserId}&BrandId=${brandId}&slugId=${slugId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // const filterData = res.data.ResponseData?.list.filter(
        //   (item) => item.slugId === slugId
        // );
        setData(res.data.ResponseData?.list);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
      });
  };

  useEffect(() => {
    if (categoryId && slugId > 0) {
      handelItemData();
    }
  }, [categoryId, brandId, slugId]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // console.log(e.key, cursorIndex, "256348");
      // toastSuccess(`${e.key} ${cursorIndex}`);

      if (!suggestions || suggestions.length === 0) return;

      if (e.key === "ArrowDown") {
        setCursorIndex((prev) => (prev + 1) % suggestions.length);
      } else if (e.key === "ArrowUp") {
        setCursorIndex(
          (prev) => (prev - 1 + suggestions.length) % suggestions.length
        );
      } else if (e.key === "Enter") {
        const item = suggestions[cursorIndex];
        updateItemIsPublicOutOfStock({
          ...item,
          VariationId: 0,
        });
        setSuggestions([]);
        setSearchItemName("");
        setCursorIndex(0);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [cursorIndex, suggestions]); // <--- key point here

  const updateItemIsPublicOutOfStock = (item) => {
    console.log(item, "add items check");

    axios
      .post(
        `${config.itemsBaseUrl}/items/updateIsPublicOutOfStock`,
        {
          itemId: item?.ID,
          itemVariationId: item?.VariationId,
          isPublicOutOfStock: item?.isPublicOutOfStock,
          isWholesaleOutOfStock: item?.isWholesaleOutOfStock,
          isPublicHide: item?.isPublicHide,
          isWholesaleHide: item?.isWholesaleHide,
          slugId: slugId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseCode);
          console.log("SetDone");
          handelItemData();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
        } else {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Ecom Inventory Stock Status</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-2">
                  <h4 className="card-title mb-0">Slug: {categoryName}</h4>
                  <div>
                    <input
                      type="search"
                      placeholder="Search..."
                      // className="form-control-sm w-100 mt-1"
                      className="search-btn form-control form-control-sm w-100"
                      onChange={(e) => {
                        setSearchItemName(e.target.value);
                      }}
                      value={searchItemName}
                    />
                    {suggestions.length > 0 ? (
                      <div
                        className="dropdown"
                        style={{ position: "relative", width: "400px" }}
                      >
                        <ul
                          className="dropdown-menu  show"
                          style={{
                            // width: "100%",
                            maxHeight: "400px",
                            overflowY: "auto",
                          }}
                        >
                          {suggestions.map((item, index) => (
                            <li
                              key={index}
                              className={
                                cursorIndex === index
                                  ? "dropdown-item active p-2"
                                  : "dropdown-item p-2"
                              }
                              onClick={(e) => {
                                updateItemIsPublicOutOfStock({
                                  ...item,
                                  VariationId: 0,
                                });
                                setSuggestions([]);
                                setSearchItemName("");
                              }}
                            >
                              <a
                                key={item.ID}
                                href="#"
                                className="d-flex gap-2"
                                data-name={item.Name.toLowerCase()}
                              >
                                <img
                                  src={item.ImageURL ? item.ImageURL : Noimage}
                                  alt={item.Name}
                                  className="img-thumbnail rounded-circle"
                                  style={{
                                    maxWidth: "55px",
                                    maxHeight: "55px",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = Noimage;
                                  }}
                                />
                                <div className="customer-info ml-2  ">
                                  <p className="name">{item.Name}</p>
                                  <div>
                                    Qty: {Number(item.Quantity).toFixed(2)} |
                                    Categories: {item?.Categoryfullpath}
                                  </div>
                                  {/* Add any other customer details here */}
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <CommonMultiSelect
                    options1={brandsList}
                    callbackvalue={setBrandId}
                    placeholder="Brands"
                    className="w-100 custom-search-select"
                  />
                  <Link
                    className="btn btn-primary"
                    to={`/inventory-stock-status`}
                  >
                    Back
                  </Link>
                </div>
              </div>
              <div>
                <CommonMatrialReactTable
                  columns={columns}
                  data={data}
                  hodiExport={true}
                  enableRowSelection={false}
                  isRowSelectionManual={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InventoryStockStatusByCategory;

